import { useEffect, useId, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ChevronDown } from "lucide-react";

export function ShopMenu({ onNavigate = () => {}, mobile = false }) {
  const [open, setOpen] = useState(false);
  const instanceId = useId().replace(/:/g, "");
  const testPrefix = mobile ? "mobile-shop-menu" : "shop-menu";
  const menuRef = useRef(null);
  const triggerRef = useRef(null);
  const pointerFocusRef = useRef(false);
  const menuId = `${testPrefix}-dropdown-${instanceId}`;

  useEffect(() => {
    if (!open) return undefined;
    const closeOnOutsidePointer = (event) => {
      if (!menuRef.current?.contains(event.target)) setOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key !== "Escape") return;
      setOpen(false);
      triggerRef.current?.focus();
    };
    document.addEventListener("pointerdown", closeOnOutsidePointer);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOnOutsidePointer);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [open]);

  const closeAfterNavigation = () => {
    setOpen(false);
    onNavigate();
  };

  return (
    <div
      ref={menuRef}
      className={`shop-menu${open ? " is-open" : ""}`}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
      }}
      data-testid={testPrefix}
    >
      <button
        ref={triggerRef}
        className="shop-menu-trigger"
        type="button"
        aria-expanded={open}
        aria-controls={menuId}
        aria-haspopup="menu"
        onPointerDown={() => {
          pointerFocusRef.current = true;
        }}
        onClick={() => {
          pointerFocusRef.current = false;
          setOpen((current) => !current);
        }}
        onFocus={() => {
          if (!pointerFocusRef.current) setOpen(true);
        }}
        data-testid={testPrefix + "-toggle"}
      >
        <span>Shop</span>
        <ChevronDown className="shop-menu-chevron" size={14} strokeWidth={1.4} />
      </button>
      {open && (
        <div id={menuId} className="shop-menu-dropdown" role="menu" aria-label="Shop options" data-testid={testPrefix + "-dropdown"}>
          <Link className="shop-menu-prints-link" to="/works#prints" onClick={closeAfterNavigation} role="menuitem" data-testid={testPrefix + "-prints-link"}>
            <span>Prints</span>
            <ArrowUpRight size={15} strokeWidth={1.3} />
          </Link>
          <Link className="shop-menu-prints-link" to="/works" onClick={closeAfterNavigation} role="menuitem" data-testid={testPrefix + "-paintings-link"}>
            <span>Paintings</span>
            <ArrowUpRight size={15} strokeWidth={1.3} />
          </Link>
        </div>
      )}
    </div>
  );
}
